import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getGoogleChatMappingsUrl } from '../../utils/Url';
import integrations from '../utils/integrations';
import { jsx as _jsx } from "react/jsx-runtime";
const MapGoogleChatAccount = ({
  appId
}) => {
  if (!integrations.isGoogleChatAppId(appId)) {
    return undefined;
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'shareWithThirdPartyComponentLibrary.chatSpaceSelector.mapAccount_jsx',
    elements: {
      Link
    },
    options: {
      href: getGoogleChatMappingsUrl(),
      external: true
    }
  });
};
export default MapGoogleChatAccount;